<template>
  <div>
    <v-container style="height: 400px;">
      <v-card class="mx-auto" max-width="600" elevation="10">
        <v-row class="fill-height" align-content="center" justify="center" >
          <v-col class="text-center" cols="12">
            {{ $t('message.login.error') }}
          </v-col>
          <v-col class="title text-center" cols="12">
            <kbd>{{ $t('message.login.unauthorizedMsg') }}</kbd> from SuperOffice
          </v-col>
          <v-col class="text-center" cols="12">
            {{ $t('message.login.contactAdmin') }}
          </v-col>
          <v-col cols="6" class="text-center">
            <v-btn text color="deep-purple accent-4" @click="retryLogin">
              {{ $t('message.login.retry') }}
            </v-btn>
          </v-col>
        </v-row>
      </v-card>
    </v-container>
  </div>
</template>
<script>
export default {
  mounted () {
    this.$store.commit('clearSession')
  },
  methods: {
    retryLogin () {
      window.open(`${process.env.VUE_APP_SO_FEDERATED_URL}&redirect_url=${process.env.VUE_APP_SO_REDIRECT_URL}`, '_blank')
    }
  }
}
</script>
